export function LandingPhilosophy() {
  return (
    <section id="philosophy" style={{ padding: "var(--lp-sec-y) 0" }}>
      <div style={{ maxWidth: 820, margin: "0 auto", padding: "0 var(--lp-gutter-x)", textAlign: "center" }}>
        <p
          data-reveal
          style={{
            fontFamily: "var(--lp-quote-serif)",
            fontWeight: 400,
            fontStyle: "italic",
            fontSize: "clamp(24px, 3.2vw, 38px)",
            lineHeight: 1.35,
            color: "var(--lp-plum-700)",
            textWrap: "balance",
          }}
        >
          &ldquo;We build BunnyCal for hosts who care how a meeting begins - because the first minute
          of a conversation starts long before anyone says hello.&rdquo;
        </p>
      </div>
    </section>
  );
}
